"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Parser_1 = require("../Parser");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var ShopSavePercentage_1 = require("./ShopSavePercentage");
var color_1 = require("../common/color");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var ShopPurchaseTypes = function (_a) {
    var _b, _c, _d;
    var stackIndex = _a.stackIndex;
    var _e = (0, hooks_1.useContext)(ShopContext_1.default), colors = _e.colors, optionIndex = _e.optionIndex, options = _e.options, purchaseTypeIndex = _e.purchaseTypeIndex, quantityIndex = _e.quantityIndex, setPurchaseTypeIndex = _e.setPurchaseTypeIndex, shopData = _e.shopData, singleProductBundle = _e.singleProductBundle;
    var upsells = (_b = shopData.upsell) === null || _b === void 0 ? void 0 : _b.references.nodes;
    return ((0, preact_1.h)("div", { class: "shop-v2__selection shop-v2__purchase-types", style: { border: "1px solid ".concat((0, color_1.toHex)(colors.selectionsBorder)) } },
        (options.length >= 2 ||
            ((_c = options[optionIndex].purchaseTypes) === null || _c === void 0 ? void 0 : _c.references.nodes[purchaseTypeIndex].products.references.nodes.length) === 3 ||
            (upsells && upsells.length === 1)) && ((0, preact_1.h)("div", { class: "shop-v2__selections-header" },
            (0, preact_1.h)("p", null,
                stackIndex,
                "."),
            (0, preact_1.h)("p", null,
                stackIndex === 1 ? 'Select ' : '',
                "Purchase Type"))), (_d = options[optionIndex].purchaseTypes) === null || _d === void 0 ? void 0 :
        _d.references.nodes.map(function (purchaseType, index) {
            var _a;
            var price = parseFloat(purchaseType.products.references.nodes[quantityIndex].priceRange.minVariantPrice.amount);
            var quantityMap = singleProductBundle ? [3, 4, 6] : [1, 2, 3];
            var pricePerQuantity = {
                amount: (price / quantityMap[quantityIndex]).toString(),
                currencyCode: 'USD',
            };
            // sub texts default value
            var isSubType = purchaseType.purchaseType.value == 'Subscribe & Save';
            var subtextPrimaryDefault = isSubType ? 'Easy to Cancel, anytime' : 'One Time Purchase';
            var subtextSecondaryDefault = isSubType && 'Free Shipping Always';
            return ((0, preact_1.h)("div", { class: "shop-v2__purchase-price-container", key: purchaseType.purchaseType.value, onClick: function () { return setPurchaseTypeIndex(index); } },
                (0, preact_1.h)("div", { class: "shop-v2__purchase-price" },
                    (0, preact_1.h)("div", { class: "shop-v2__purchase-selection" },
                        (0, preact_1.h)("input", { style: {
                                outline: "2px solid ".concat((0, color_1.toHex)(colors.radio.border)),
                                backgroundColor: "".concat(purchaseTypeIndex === index ? (0, color_1.toHex)(colors.radio.bgColor) : 'transparent'),
                            }, type: "radio", name: "purchase type", id: purchaseType.purchaseType.value, checked: purchaseTypeIndex === index, value: purchaseType.purchaseType.value }),
                        (0, preact_1.h)("label", { class: "shop-v2__purchase-type", for: purchaseType.purchaseType.value }, shopData.hasSavePercentage.value === 'true' && index === 0 ? ((0, preact_1.h)(ShopSavePercentage_1.default, null)) : (purchaseType.purchaseType.value))),
                    (0, preact_1.h)("div", null, (0, hydrogen_react_1.useMoney)(pricePerQuantity).withoutTrailingZeros)),
                (0, preact_1.h)("div", { class: "shop-v2__subtext-purchase-unit" },
                    (0, preact_1.h)("div", { class: "shop-v2__subtexts" },
                        (0, preact_1.h)("div", { class: "shop-v2__subtext-primary" }, (purchaseType.subtextPrimary && (0, Parser_1.parse)(purchaseType.subtextPrimary.value)) ||
                            subtextPrimaryDefault),
                        (0, preact_1.h)("div", { class: "shop-v2__subtext-secondary", style: { color: "".concat((0, color_1.toHex)(colors.freeShippingAlways)) } }, ((_a = purchaseType.subtextSecondary) === null || _a === void 0 ? void 0 : _a.value) || subtextSecondaryDefault)),
                    (0, preact_1.h)("div", { class: "shop-v2__purchase-unit" },
                        "/",
                        options[optionIndex].purchaseUnit.value))));
        })));
};
exports.default = ShopPurchaseTypes;
